import type { ReactNode } from 'react';
import { Dialog } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { i18nService } from '../../services/i18n';
import styles from './AccountDialog.module.css';

/** 账户子弹窗复用焦点、键盘、层级和动画；门户事件不能连带关闭外层设置。 */
export default function AccountDialog({ title, description, children, footer, onClose, wide = false, fixedHeight = false, testId }: {
  title: string; description?: string; children: ReactNode; footer?: ReactNode;
  /** 只关闭视图，付款等业务状态由父组件继续管理。 */
  onClose: () => void;
  wide?: boolean; testId?: string;
  /** 多页签明细保持统一高度，内容区自行滚动；小屏仍限制在视口内。 */
  fixedHeight?: boolean;
}) {
  return <Dialog open onClose={onClose} className="relative z-[150]" onClick={event => event.stopPropagation()}
    onKeyDown={event => {
      if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); onClose(); }
    }}>
    <div className={`fixed inset-0 bg-black/40 backdrop-blur-sm ${styles.backdrop}`} aria-hidden="true" />
    <div className="fixed inset-0 flex items-center justify-center p-3">
      <Dialog.Panel data-testid={testId} className={`flex max-h-[90dvh] w-full ${fixedHeight ? 'h-[760px]' : ''} ${wide ? 'max-w-3xl' : 'max-w-xl'} flex-col rounded-2xl border border-claude-border dark:border-claude-darkBorder bg-claude-bg dark:bg-claude-darkBg p-5 text-claude-text dark:text-claude-darkText shadow-xl ${styles.panel}`}>
        <div className="flex shrink-0 items-start justify-between gap-3">
          <Dialog.Title className="text-base font-semibold">{title}</Dialog.Title>
          <button type="button" aria-label={i18nService.t('close')} onClick={onClose} className="shrink-0 rounded-lg p-1.5 hover:bg-black/5 dark:hover:bg-white/10 transition-colors"><XMarkIcon aria-hidden="true" className="h-5 w-5" /></button>
        </div>
        {description && <Dialog.Description className="mt-2 shrink-0 text-xs text-claude-textSecondary dark:text-claude-darkTextSecondary">{description}</Dialog.Description>}
        {children}
        {footer && <div className="mt-3 flex shrink-0 justify-end border-t border-claude-border dark:border-claude-darkBorder pt-3">{footer}</div>}
      </Dialog.Panel>
    </div>
  </Dialog>;
}
